export default __webpack_public_path__ + "static/media/sadem1.eefaaf4e.jpg";